module.exports = __webpack_public_path__ + "img/boat.5bb8e84b.png";